import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.87501 8.25C9.42799 8.25 10.6875 6.99049 10.6875 5.4375C10.6875 3.88389 9.42799 2.625 7.87501 2.625C6.32203 2.625 5.06252 3.88389 5.06252 5.4375C5.05693 6.9849 6.30776 8.24442 7.85515 8.25H7.87501Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.875 15C5.24586 15 3 14.6442 3 13.2199C3 11.7955 5.23139 10.5 7.875 10.5C10.5041 10.5 12.75 11.7832 12.75 13.2069C12.75 14.6307 10.5186 15 7.875 15Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.875 7.125V10.875",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.75 9L12 9",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgUserPlus);
export { ForwardRef as ReactComponent };
